import GS from '../../grafsync/grafsync';
import PropTypes from 'prop-types';
import React from 'react';
import withGS from '../../core/withGShoc';
import ShaclPropertyPath from './ShaclPropertyPath';

class ShaclProperty extends React.Component {

    state = {
        patternTest: ""
    };

    updatePatternTest = (patternTest) => this.setState({ patternTest });

    onDeletePattern = (value) => {
        this.props.onDelete("shPattern", value);
        this.setState({ patternTest: '' });
    };

    onDeleteValue = (prop) => (value) => {
        this.props.onDelete(prop, value);
    };

    addNewLiteral = (property) => (language, text) => {
        GS.addProperty(this.props.id, this.props.graph, property, text, language, null);
    };

    onUpdate = (property, lang, index) => (value) => this.props.onUpdate(property, value, lang, index);

    onDelete = (property, lang) => (value) => this.props.onDelete(property, value, lang);

    onSetPattern = (value) => {
        const exists = this.props.data["shPattern"];
        if (!exists) {
            this.props.onAdd("shPattern", value);
        }
        else this.props.onUpdate("shPattern", value);
    };

    onSetMinCount = (value) => {
        const minCount = parseInt(value);
        const exists = this.props.data["shMinCount"];
        if (!exists) {
            this.props.onAdd("shMinCount", minCount);
        }
        else this.props.onUpdate("shMinCount", minCount);
    };

    onSetMaxCount = (value) => {
        const maxCount = parseInt(value);
        const exists = this.props.data["shMaxCount"];
        if (!exists) {
            this.props.onAdd("shMaxCount", maxCount);
        }
        else this.props.onUpdate("shMaxCount", maxCount);
    };

    onSetMaxLength = (value) => {
        const maxLength = parseInt(value);
        const exists = this.props.data["shMaxLength"];
        if (!exists) {
            this.props.onAdd("shMaxLength", maxLength);
        }
        else this.props.onUpdate("shMaxLength", maxLength);
    };

    onAddComponent = (iri) => {
        if (!this.props.data.inComponent || !this.props.data.inComponent.includes(iri)) {
            this.props.onAdd("inComponent", iri);
        }
    };

    render() {

        const { data, defaultLang, dataTest, id, isReadOnly, graph, ontologyProjectGraph, buildLink, onDeleteLink, project } = this.props;
        const { patternTest } = this.state;
        const shPath = data.shPath;
        if (!shPath) return null;

        return (
            <ShaclPropertyPath
                dataTest={dataTest}
                key={shPath}
                id={shPath}
                propertyShapeData={data}
                onDeleteLink={onDeleteLink}
                buildLink={buildLink}
                project={project}
                suppressLoading={true}
                patternTest={patternTest}
                onSetMinCount={this.onSetMinCount}
                onSetMaxCount={this.onSetMaxCount}
                onSetMaxLength={this.onSetMaxLength}
                onAddComponent={this.onAddComponent}
                onDeletePattern={this.onDeletePattern}
                onSetPattern={this.onSetPattern}
                updatePatternTest={this.updatePatternTest}
                onDeleteValue={this.onDeleteValue}
                onUpdate={this.onUpdate}
                onDelete={this.onDelete}
                onAddLanguage={this.addNewLiteral}
                link={buildLink}
                handleNotAvailable={true}
                isReadOnly={isReadOnly}
                projectGraph={graph}
                graph={ontologyProjectGraph}
                source={id}
                viewLang={defaultLang}
                defaultLang={defaultLang} />
        );
    }
}

ShaclProperty.defaultProps = {
    isReadOnly: false
};

ShaclProperty.propTypes = {
    dataTest:PropTypes.string,
    data: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    buildLink: PropTypes.func.isRequired,
    project: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    onDeleteLink: PropTypes.func.isRequired,
    ontologyProjectGraph: PropTypes.string.isRequired,
    isReadOnly: PropTypes.bool,
    defaultLang: PropTypes.string.isRequired
};

export default withGS(ShaclProperty);